@if (child(); as child) {
  <app-center-child-guard [centerChild]="centerChild()!">
    <app-container>
      <section
        class="container mx-auto flex flex-col w-full h-full gap-2 xs:pt-10 xl:pt-[40px] xl:pb-6 xl:mx-0"
      >
        <router-outlet />
      </section>
    </app-container>
  </app-center-child-guard>
}
